import React, { useEffect, useState } from "react";
import infoimg from "../CreateModal/info.png";
import { Button, Grid, Switch, TextField, Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import localforage from "localforage";
import Icons from "../components/icon";
import CreateIcon from "@mui/icons-material/Create";
import { useUsersContext } from "../../../../context/usersContext";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { useUserInfo } from "../../../../context/user";
import { useQueryClient } from "@tanstack/react-query";
import { useUpdateAgent, agentsKeys } from "../../../../queries/agents";

function ModalComponent({
  open,
  onClose,
  item,
  handleRefresh,
  assistant_type,
  pluginsdata,
}) {
  const queryClient = useQueryClient();
  const updateAgent = useUpdateAgent();
  const userInfo = useUserInfo()[0];
  const userActiveLocation = useUserInfo()[4];
  const [contentCreativity, setContentCreativity] = useState(
    item?.content_creativity,
  );
  const [btgen, setBtgen] = useState(item.btgen);
  const [waiting, setWaiting] = useState(false);
  const [tags, setTags] = useState(
    item.prompt_label_ids.map((data) => data._id),
  );
  const [checkbox, setCheckbox] = useState(item.readonly);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setWaiting(true);
    const activelocation = await localforage.getItem("active_location");

    const payload = {
      assistant_name: e.target.assistant_name.value,
      purpose: e.target.purpose.value,
      modal_name: "openai/gpt-4o",
      type: "account",
      content_creativity: parseFloat(contentCreativity),
      btgen: parseFloat(btgen),
      prompt_label_ids: tags,
      account_id: activelocation.id,
      _id: item._id,
      readonly: checkbox,
      assistant_id: item.assistant_id,
      advanceConversationMode: advanceConversationMode,
      numberOfMessages: numberOfMessages,
      messageDelayTime: messageDelayTime,
      function_names: editplugins
        ? editplugins.filter((item) => item !== "")
        : editplugins,
    };

    try {
      await updateAgent.mutateAsync(payload);
      setShowAdvancedSettings(false);
      queryClient.invalidateQueries({
        queryKey: agentsKeys.list(userInfo?._id, userActiveLocation?.id),
      });
      handleRefresh();
      onClose();
    } catch (error) {
      console.error("Error updating assistant:", error);
    } finally {
      setWaiting(false);
    }
  };

  const handleCCInputChange = (event) => {
    const tempSliderValue = parseFloat(event.target.value);
    const maxSliderValue = parseFloat(event.target.max);
    const progress = (tempSliderValue / maxSliderValue) * 100;

    const rangeInput = document.querySelector(".range-input");
    if (rangeInput) {
      rangeInput.style.background = `linear-gradient(to right, hsl(var(--muted-foreground)) ${progress}%, hsl(var(--border)) ${progress}%)`;
    }

    setContentCreativity(tempSliderValue);
  };

  const handleBtInputChange = (event) => {
    const tempSliderValue = parseFloat(event.target.value);
    const maxSliderValue = parseFloat(event.target.max);
    const progress = (tempSliderValue / maxSliderValue) * 100;

    const rangeInput = document.querySelector(".range-input1");
    if (rangeInput) {
      rangeInput.style.background = `linear-gradient(to right, hsl(var(--muted-foreground)) ${progress}%, hsl(var(--border)) ${progress}%)`;
    }
    setBtgen(tempSliderValue);
  };

  const handlechecbox = () => {
    setCheckbox(!checkbox);
  };
  const [showAdvancedSettings, setShowAdvancedSettings] = useState(false);
  const [advanceConversationMode, setAdvanceConversationMode] = useState(
    item?.advanceConversationMode,
  ); // State for the toggle button
  const [numberOfMessages, setNumberOfMessages] = useState(
    item?.numberOfMessages,
  ); // State for the first number input field
  const [messageDelayTime, setMessageDelayTime] = useState(
    item?.messageDelayTime,
  );
  const [editplugins, setEditPlugins] = useState(item.function_names);

  useEffect(() => {
    setEditPlugins(item?.function_names || []); // Update state whenever item plugins change
    setNumberOfMessages(item?.numberOfMessages);
    setMessageDelayTime(item?.messageDelayTime);
    setAdvanceConversationMode(item?.advanceConversationMode);
  }, [item?.function_names]);
  // Toggle Advanced Settings
  const handleAdvancedSettingsClick = () => {
    setShowAdvancedSettings(!showAdvancedSettings);
  };

  // Handle Toggle Button Change
  const handleToggleChange = (event) => {
    setAdvanceConversationMode(event.target.checked);
  };

  // Handle Number Input Change
  const handleNumberInputChange = (event, setter) => {
    setter(event.target.value);
  };

  const handlePluginsChange = (event) => {
    const plugin = pluginsdata?.find(
      (plugin) => plugin.name === event.target.name,
    );
    if (!plugin) return; // Ensure the plugin exists

    const pluginName = plugin.name;

    setEditPlugins(
      (prevState) =>
        prevState.includes(pluginName)
          ? prevState.filter((name) => name !== pluginName) // Remove if already included
          : [...prevState, pluginName], // Add if not included
    );
  };

  const formatString = (str) => {
    // Replace underscores with spaces
    str = str.replace(/_/g, " ");

    // Add space before each capital letter, ensuring no double spaces
    str = str.replace(/([a-z])([A-Z])/g, "$1 $2");

    // Trim and return the final result
    return str.trim();
  };

  return (
    <>
      {open && (
        <div className="modal-zz-confirm text-left">
          <div
            className="p-2 scrollable-modal-content bg-card rounded"
            style={{
              position: "relative",
              minWidth: "400px",
              width: "500px",
              minheight: "500px!important",
              height: "500px",
            }}
          >
            {/* Info Message */}
            {assistant_type == "account" || assistant_type == "user" ? (
              <div
                style={{
                  backgroundColor: "#0588e9",
                  color: "white",
                  padding: "5px 10px",
                  borderRadius: "5px",
                  marginBottom: "12px",
                  marginTop: "20px",
                }}
              >
                <p style={{ fontSize: "13px" }}>
                  Warning: To update the template for all agents, please go to
                  the User/Account Templates tab. To update this agent only, you
                  can make the changes directly from this page. Continue.
                </p>
              </div>
            ) : (
              ""
            )}
            <h2
              className="text-foreground text-left"
              style={{ fontWeight: "700" }}
            >
              {" "}
              Edit Agent{" "}
            </h2>
            <span
              style={{
                position: "absolute",
                right: "10px",
                top: "10px",
                cursor: "pointer",
              }}
              onClick={onClose}
            >
              X
            </span>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={0}>
                <Grid item xs={12}>
                  <div className="mt-2">
                    <label className="text-foreground">Agent Name</label>
                    <input
                      className="form-control-agust"
                      placeholder="Agent Name"
                      name="assistant_name"
                      defaultValue={item.assistant_name}
                      required
                    />
                  </div>
                </Grid>

                <Grid item xs={12} style={{ marginTop: "14px" }}>
                  <div className="mt-2">
                    <label
                      className="text-foreground"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <span>Purpose</span>

                      <Tooltip
                        PopperProps={{
                          sx: {
                            "& .MuiTooltip-tooltip": {
                              maxWidth: "none",
                              width: "400px", // Set your desired width here
                            },
                          },
                        }}
                        placement="top"
                        title={"supperAdminData?.assistant_purpose"}
                      >
                        <img
                          style={{ width: "30px", cursor: "pointer" }}
                          src={infoimg}
                        />
                      </Tooltip>
                    </label>

                    <textarea
                      className="form-control-agust"
                      name="purpose"
                      rows={4}
                      style={{
                        width: "100%",
                        padding: "14px",
                        resize: "vertical",
                      }}
                      defaultValue={item.purpose}
                      required
                    ></textarea>
                  </div>
                </Grid>

                <Grid item xs={6} style={{ marginTop: "10px" }}>
                  <div className="mt-2">
                    <label
                      className="text-foreground"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <span>Content Creativity</span>

                      <Tooltip
                        PopperProps={{
                          sx: {
                            "& .MuiTooltip-tooltip": {
                              maxWidth: "none",
                              width: "400px", // Set your desired width here
                            },
                          },
                        }}
                        placement="top"
                        title={"supperAdminData?.content_creativity"}
                      >
                        <img
                          style={{ width: "30px", cursor: "pointer" }}
                          src={infoimg}
                        />
                      </Tooltip>
                    </label>

                    <div style={{ display: "flex", alignItems: "center" }}>
                      <input
                        value={contentCreativity}
                        type="range"
                        min="0"
                        max="2"
                        step=".01"
                        onChange={handleCCInputChange}
                        className="range-input"
                      />
                      <input
                        type="number"
                        value={contentCreativity}
                        min="0"
                        max="2"
                        step=".01"
                        onChange={(event) => handleCCInputChange(event)}
                        style={{
                          maxWidth: "50px",
                          fontSize: "14px",
                          margin: "2px",
                          padding: "0px 2px",
                          borderRadius: "5px",
                          border: "1px solid Black",
                        }}
                        className="height_25 bg_transparent"
                      />
                    </div>
                  </div>
                </Grid>

                <Grid item xs={6} style={{ marginTop: "10px" }}>
                  <div className="mt-2">
                    <label
                      className="text-foreground"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <span>Balance Text Generation</span>

                      <Tooltip
                        PopperProps={{
                          sx: {
                            "& .MuiTooltip-tooltip": {
                              maxWidth: "none",
                              width: "400px", // Set your desired width here
                            },
                          },
                        }}
                        placement="top"
                        title={"supperAdminData?.balance_text_generation"}
                      >
                        <img
                          style={{ width: "30px", cursor: "pointer" }}
                          src={infoimg}
                        />
                      </Tooltip>
                    </label>

                    <div style={{ display: "flex", alignItems: "center" }}>
                      <input
                        value={btgen}
                        type="range"
                        min="0"
                        max="1"
                        step=".01"
                        onChange={handleBtInputChange}
                        className="range-input1"
                      />
                      <input
                        type="number"
                        value={btgen}
                        min="0"
                        max="1"
                        step="0.01"
                        onChange={(event) => handleBtInputChange(event)}
                        style={{
                          maxWidth: "50px",
                          fontSize: "14px",
                          margin: "2px",
                          padding: "0px 2px",
                          borderRadius: "5px",
                          border: "1px solid Black",
                        }}
                        className="height_25 bg_transparent"
                      />
                    </div>
                  </div>
                </Grid>
              </Grid>

              {/* Advanced Settings Button */}
              <div style={{ width: "100%", textAlign: "right" }} mt={2}>
                <Button
                  onClick={handleAdvancedSettingsClick}
                  style={{ color: "hsl(var(--foreground))" }}
                >
                  Advanced Settings
                </Button>
              </div>

              {showAdvancedSettings && (
                <div style={{ padding: "10px" }}>
                  <h2
                    className="text-foreground text-left"
                    style={{
                      fontWeight: "700",
                      marginBottom: "20px",
                      marginLeft: "-15px",
                    }}
                  >
                    {" "}
                    Advance Setting{" "}
                  </h2>

                  <Grid container spacing={2}>
                    {/* Toggle Button */}
                    {/* <Grid item xs={12} style={{ marginBottom: '20px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <label className="text-foreground" style={{ marginRight: '0px' }}>Switch on advanced conversation mode</label>
                          <Tooltip PopperProps={{
                            sx: {
                              "& .MuiTooltip-tooltip": {
                                maxWidth: "none",
                                width: "400px",
                                marginTop: "30px"
                              },
                            },
                          }} placement="top" title={supperAdminData.pluginInfo}>
                            <img style={{ width: "30px", cursor: "pointer" }} src={infoimg} />
                          </Tooltip>
                        </div>
                        <div>

                          <Switch
                            checked={advanceConversationMode}
                            onChange={handleToggleChange}
                            name="enableFeature"
                            inputProps={{ 'aria-label': 'Enable Feature' }}
                            sx={{
                              '& .MuiSwitch-switchBase.Mui-checked': {
                                color: 'hsl(var(--muted-foreground))', // Change the color of the switch thumb when checked
                              },
                              '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                backgroundColor: 'hsl(var(--muted-foreground))', // Change the track color when checked
                              },
                              '& .MuiSwitch-track': {
                                backgroundColor: advanceConversationMode ? 'hsl(var(--muted-foreground))' : 'hsl(var(--muted-foreground))', // Default to grey color when unchecked
                              }
                            }}
                            style={{ backgroundColor: "hsl(var(--muted-foreground))" }}
                          />
                        </div>
                      </div>
                    </Grid> */}

                    {/* Number Input Field 1 */}
                    {/* <Grid item xs={12} style={{ marginBottom: '15px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <label className="text-foreground">Number of messages</label>
                        <TextField
                          className="numberMessages"
                          type="number"
                          value={numberOfMessages}
                          onChange={(e) => handleNumberInputChange(e, setNumberOfMessages)}
                          fullWidth
                          inputProps={{
                            min: 2,
                            max: 10, // Set max to 10
                            step: 1 // Optional: Only allow whole numbers
                          }}
                          style={{
                            width: '30%',
                            padding: '0 8px',
                            height: '16px !important',
                            fontSize: '14px',
                            lineHeight: '16px',
                          }}
                        />
                      </div>
                    </Grid> */}

                    {/* Number Input Field 2 */}
                    {/* <Grid item xs={12} style={{ marginBottom: '10px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <label className="text-foreground">Delay between messages Seconds:</label>
                        <TextField
                          type="number"
                          value={messageDelayTime}
                          onChange={(e) => handleNumberInputChange(e, setMessageDelayTime)}
                          fullWidth
                          inputProps={{ min: 0 }}
                          style={{
                            width: '30%',
                            // Set the height of the TextField input
                            padding: '0 8px', // Adjust the padding to match the reduced height
                          }}
                        />
                      </div>
                    </Grid> */}
                    {pluginsdata && (
                      <>
                        <h2
                          className="text-foreground text-left"
                          style={{ fontWeight: "700", marginBottom: "20px" }}
                        >
                          {" "}
                          Plugins{" "}
                        </h2>
                        {pluginsdata?.map((plugin) => (
                          <Grid
                            item
                            xs={12}
                            style={{ marginBottom: "20px" }}
                            key={plugin.id}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <label
                                className="text-foreground"
                                style={{ marginRight: "10px" }}
                              >
                                {formatString(plugin.name).toUpperCase()}
                              </label>
                              <Switch
                                checked={editplugins.includes(plugin.name)}
                                onChange={handlePluginsChange}
                                name={plugin.name}
                                inputProps={{
                                  "aria-label": `Enable ${formatString(
                                    plugin.name,
                                  )}`,
                                }}
                              />
                            </div>
                          </Grid>
                        ))}
                      </>
                    )}
                  </Grid>
                </div>
              )}

              <div style={{ textAlign: "right" }} mt={2}>
                <button
                  className="savebtn-setting w-100"
                  type="submit"
                  disabled={waiting}
                >
                  {waiting && (
                    <div
                      class="spinner"
                      style={{
                        width: "16px",
                        height: "16px",
                        display: "inline-block",
                        marginRight: "8px",
                      }}
                    ></div>
                  )}
                  Update Agent
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

ModalComponent.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  handleRefresh: PropTypes.func,
};

function Modal({ item }) {
  const userInfo = useUserInfo()[0];
  const { agentBuilder, setSelectedAssistant } = useUsersContext();
  const navigate = useNavigate();

  const handleEditAgent = async () => {
    if (item?.thread_id) {
      setSelectedAssistant({
        assistant_id: agentBuilder,
        assistant_name: "Agent Builder",
        message: "edit mode",
        conversationId: item.thread_id,
      });
      setTimeout(() => {
        navigate(`/app/chat/${item?.thread_id}`);
      }, 100);
    } else {
      toast.error("Agent not created by agent builder");
    }
  };

  if (item?.disabledBySuperAdmin)
    return (
      <Tooltip title="Disabled by super admin" placement="top">
        <span
          className="flex justify-between items-center w-full text-[12px]"
          style={{ padding: "5px 0px", cursor: "not-allowed", opacity: 0.5 }}
        >
          Edit <CreateIcon className="!w-[12px] ml-auto" />
        </span>
      </Tooltip>
    );

  if (item?.created_by?._id !== userInfo?._id)
    return (
      <Tooltip
        title={`Only the creator ${item?.created_by?.userName} can edit`}
        placement="top"
      >
        <span
          className="flex justify-between items-center w-full text-[12px]"
          style={{ padding: "5px 0px", cursor: "not-allowed" }}
        >
          Edit <CreateIcon className="!w-[12px] ml-auto" />
        </span>
      </Tooltip>
    );

  return (
    <>
      <span
        onClick={handleEditAgent}
        className="flex justify-between items-center w-full text-[12px]"
        style={{ padding: "5px 0px", cursor: "pointer" }}
      >
        Edit <CreateIcon className="!w-[12px] ml-auto" />
      </span>
      {/* <ModalComponent
        open={openAddMember}
        onClose={() => setOpenAddMember(false)}
        item={item}
        handleRefresh={handleRefresh}
        assistant_type={assistant_type}
        pluginsdata={pluginsdata}
      /> */}
    </>
  );
}

Modal.propTypes = {
  products: PropTypes.array,
  handleRefresh: PropTypes.func,
  apps: PropTypes.array,
};

export default Modal;
